export const beds = {
  1: { singular: 'letto singolo', plural: 'letti singoli' },
  2: { singular: 'letto matrimoniale alla francese', plural: 'letti matrimoniali alla francese' },
  3: { singular: 'letto matrimoniale large', plural: 'letti matrimoniali large' },
  4: { singular: 'letto a castello', plural: 'letti a castello' },
  5: { singular: 'divano letto', plural: 'divani letto' },
  6: { singular: 'letto matrimoniale', plural: 'letti matrimoniali' },
  7: { singular: 'futon', plural: 'futon' }
}

export function get_beds(key, number_of_beds) {
  const bed_type = beds[key]
  if (bed_type !== undefined) {
    return `${number_of_beds} ` + (number_of_beds > 1 ? `${bed_type.plural}` : `${bed_type.singular}`)
  }
}